<dialog-header
  [image]="integration.image"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    padding-bottom: 20px;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <mat-tab-group
    mat-align-tabs="start"
    mat-stretch-tabs="false"
    disableRipple="true"
    [animationDuration]="0"
    [(selectedIndex)]="selectedIndex"
    (selectedTabChange)="tabChanged($event.index)"
  >
    <mat-tab label="Overview">
      <div class="form-field" style="margin-top: 10px">
        <p class="dialog-body" [innerHTML]="overviewText"></p>
      </div>

      <div
        class="form-field"
        style="margin-top: 20px"
        *ngIf="integration.value == integrations.zapier"
      >
        <div class="form-field-label" style="color: var(--app-timber)">
          Popular Zap Templates
        </div>
        <p class="dialog-body" style="margin-bottom: 15px; font-size: 14px">
          Get started quickly with these pre-built Zap templates:
        </p>
        <div
          style="
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            gap: 15px;
          "
        >
          <a
            href="https://zapier.com/webintent/create-zap?template=255702614"
            target="_blank"
            class="zap-template-card"
          >
            <div style="font-weight: 500; margin-top: 8px">
              Add Remy Rewards customers to Mailchimp
            </div>
          </a>
          <a
            href="https://zapier.com/webintent/create-zap?template=255702616"
            target="_blank"
            class="zap-template-card"
          >
            <div style="font-weight: 500; margin-top: 8px">
              Create Acuity coupons for Remy rewards
            </div>
          </a>
          <a
            href="https://zapier.com/webintent/create-zap?template=255702619"
            target="_blank"
            class="zap-template-card"
          >
            <div style="font-weight: 500; margin-top: 8px">
              Create WooCommerce coupons for Remy rewards
            </div>
          </a>
          <a
            href="https://zapier.com/webintent/create-zap?template=255702624"
            target="_blank"
            class="zap-template-card"
          >
            <div style="font-weight: 500; margin-top: 8px">
              Award Remy stamps/points for Acuity appointments
            </div>
          </a>
          <a
            href="https://zapier.com/webintent/create-zap?template=255702625"
            target="_blank"
            class="zap-template-card"
          >
            <div style="font-weight: 500; margin-top: 8px">
              Award Remy stamps/points for WooCommerce orders
            </div>
          </a>
        </div>
      </div>

      <app-info-box
        *ngIf="!hasIntegration"
        [canDismiss]="false"
        [title]="
          'Please contact us to enable the ' +
          integration.label +
          ' Integration'
        "
      ></app-info-box>
    </mat-tab>

    <mat-tab
      [label]="
        integration.value === integrations.make ||
        integration.value === integrations.zapier
          ? 'Connection'
          : 'Settings'
      "
      *ngIf="hasIntegration"
    >
      <!-- Squarespace -->
      <div
        style="margin-top: 20px"
        *ngIf="integration.value == integrations.squarespace"
      >
        <form [formGroup]="form">
          <div
            class="form-field"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
          >
            <app-primary-button
              [disabled]="loading || saving"
              [title]="'CONNECT TO SQUARESPACE'"
              image="../../../assets/squarespace_logo_small.png"
              (tapped)="connectOauth()"
              color="black"
              border="1px solid var(--app-timber)"
            ></app-primary-button>
            <p
              style="margin-top: 5px; font-style: italic; font-size: 14px"
              *ngIf="squarespaceConfig?.oauth?.id"
            >
              Last connected:
              <span style="color: blueviolet">{{
                squarespaceConfig?.oauth?.updatedOn | date: constants.longDate
              }}</span>
            </p>
          </div>

          <div
            *ngIf="squarespaceConfig?.oauth?.id"
            class="form-field"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div class="form-field-label">
              Invite customers without a Remy account via email<span>
                <info-icon [text]="inviteUsersTooltip"></info-icon>
              </span>
              <link-text
                (onTapped)="viewExampleMail()"
                text="View sample email"
              ></link-text>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="inviteUsersSquarespace"
              (change)="inviteUsersSquarespace = !inviteUsersSquarespace"
            >
            </mat-slide-toggle>
          </div>

          <div *ngIf="squarespaceConfig?.oauth?.id">
            <div class="form-field">
              <div class="form-field-label" style="color: var(--app-timber)">
                Configurations
              </div>

              <div style="margin-bottom: 20px">
                <div
                  class="social-container"
                  *ngFor="let item of squarespaceConfig?.configurations"
                  style="
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <div
                      class="form-field-label"
                      style="
                        margin-bottom: 0px !important;
                        color: black;
                        font-size: 16px;
                      "
                    >
                      {{ rowLabel(item) }}
                    </div>
                  </div>

                  <div>
                    <mat-icon
                      style="
                        color: var(--app-timber);
                        cursor: pointer;
                        margin-right: 5px;
                      "
                      (click)="editConfiguration(item)"
                      >edit</mat-icon
                    >
                    <mat-icon
                      style="color: red; cursor: pointer"
                      (click)="deleteConfiguration(item._id!)"
                      >cancel</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div
                *ngIf="canAddConfiguration"
                class="add-container"
                (click)="addConfiguration()"
              >
                <div class="popup-subtitle" style="color: var(--app-text-grey)">
                  + Add a Configuration
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Shopify -->
      <div
        style="margin-top: 20px"
        *ngIf="integration.value == integrations.shopify"
      >
        <form [formGroup]="form">
          <div class="form-field" style="margin-top: 20px">
            <div
              class="form-field-label"
              style="color: var(--app-timber); margin-bottom: 0px"
            >
              Webhook URL
            </div>
            <link-text
              (onTapped)="showInfoDialog(titleOne, bodyOne)"
              text="What should I do with this?"
            ></link-text>

            <div style="display: flex; align-items: center; cursor: pointer">
              <input
                type="text"
                class="form-input"
                [formControl]="webhookFormControl"
              />
              <div class="copy" (click)="copyWebhookUrl()">
                <mat-icon class="copy-icon">{{ "content_copy" }}</mat-icon
                ><span>Copy</span>
              </div>
            </div>
          </div>

          <div class="form-field" style="margin-top: 20px">
            <div
              class="form-field-label"
              style="
                color: var(--app-timber);
                margin-bottom: 0px;
                margin-top: 20px;
              "
            >
              Webhook Signing Key<span style="color: red">*</span>
            </div>

            <link-text
              (onTapped)="showInfoDialog(titleTwo, bodyTwo)"
              text="Where can I find this?"
            ></link-text>

            <div style="display: flex; align-items: center">
              <input
                type="text"
                class="form-input"
                [formControl]="shopifySigningKey"
              />
            </div>
          </div>

          <div
            class="form-field"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div class="form-field-label">
              Invite customers without a Remy account via email<span>
                <info-icon [text]="inviteUsersTooltip"></info-icon>
              </span>
              <link-text
                (onTapped)="viewExampleMail()"
                text="View sample email"
              ></link-text>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="inviteUsersShopify"
              (change)="inviteUsersShopify = !inviteUsersShopify"
            >
            </mat-slide-toggle>
          </div>

          <div *ngIf="shopifyConfig?.signingKey">
            <div class="form-field">
              <div class="form-field-label" style="color: var(--app-timber)">
                Configurations
              </div>

              <div style="margin-bottom: 20px">
                <div
                  class="social-container"
                  *ngFor="let item of shopifyConfig?.configurations"
                  style="
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <div
                      class="form-field-label"
                      style="
                        margin-bottom: 0px !important;
                        color: black;
                        font-size: 16px;
                      "
                    >
                      {{ rowLabel(item) }}
                    </div>
                  </div>

                  <div>
                    <mat-icon
                      style="
                        color: var(--app-timber);
                        cursor: pointer;
                        margin-right: 5px;
                      "
                      (click)="editConfiguration(item)"
                      >edit</mat-icon
                    >
                    <mat-icon
                      style="color: red; cursor: pointer"
                      (click)="deleteConfiguration(item._id!)"
                      >cancel</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div
                *ngIf="canAddConfiguration"
                class="add-container"
                (click)="addConfiguration()"
              >
                <div class="popup-subtitle" style="color: var(--app-text-grey)">
                  + Add a Configuration
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Square -->
      <div
        style="margin-top: 20px"
        *ngIf="integration.value == integrations.square"
      >
        <form [formGroup]="form">
          <div
            class="form-field"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            "
          >
            <app-primary-button
              [disabled]="loading || saving"
              [title]="'CONNECT TO SQUARE'"
              image="../../../assets/square-logo.png"
              (tapped)="connectOauth()"
              color="black"
              border="1px solid var(--app-timber)"
            ></app-primary-button>
            <p
              style="margin-top: 5px; font-style: italic; font-size: 14px"
              *ngIf="squareConfig?.oauth?.updatedOn"
            >
              Last connected:
              <span style="color: blueviolet">{{
                squareConfig?.oauth?.updatedOn | date: constants.longDate
              }}</span>
            </p>
          </div>

          <div *ngIf="squareConfig?.oauth?.updatedOn">
            <div
              *ngIf="squareConfig?.oauth?.updatedOn"
              class="form-field"
              style="
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div class="form-field-label">
                Automatically create customers in Square<span>
                  <info-icon [text]="addCustomersTooltip"></info-icon>
                </span>
              </div>
              <mat-slide-toggle
                [disabled]="false"
                [checked]="addSquareCustomers"
                (change)="addSquareCustomers = !addSquareCustomers"
              >
              </mat-slide-toggle>
            </div>

            <p
              *ngIf="addSquareCustomers"
              style="margin-top: 5px; font-style: italic; font-size: 14px"
              [innerHTML]="squareScanCustomersNote"
            ></p>

            <div
              class="form-field"
              style="margin-top: 20px"
              *ngIf="addSquareCustomers && squareConfig"
            >
              <app-primary-button
                [disabled]="loading || saving || syncing"
                [title]="syncing ? 'Syncing...' : 'Sync Customers'"
                (tapped)="syncCustomers('square')"
                color="var(--app-timber)"
                bgColor="white"
                border="1px solid var(--app-timber)"
                icon="sync"
              ></app-primary-button>
              <p
                style="
                  margin-top: 5px;
                  font-style: italic;
                  font-size: 14px;
                  color: var(--app-text-grey);
                "
              >
                Push your existing Remy customers to your Square customer
                directory and update their reference ID so the loyalty card QR
                code can be scanned at checkout
              </p>
            </div>

            <div
              class="form-field"
              style="
                margin-top: 20px;
                display: flex;
                justify-content: space-between;
              "
            >
              <div class="form-field-label">
                Invite customers without a Remy account via email<span>
                  <info-icon [text]="inviteUsersTooltip"></info-icon>
                </span>
                <link-text
                  (onTapped)="viewExampleMail()"
                  text="View sample email"
                ></link-text>
              </div>
              <mat-slide-toggle
                [disabled]="false"
                [checked]="inviteUsersSquare"
                (change)="inviteUsersSquare = !inviteUsersSquare"
              >
              </mat-slide-toggle>
            </div>

            <div class="form-field">
              <div class="form-field-label" style="color: var(--app-timber)">
                Configurations
              </div>

              <div style="margin-bottom: 20px">
                <div
                  class="social-container"
                  *ngFor="let item of squareConfig?.configurations"
                  style="
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <div
                      class="form-field-label"
                      style="
                        margin-bottom: 0px !important;
                        color: black;
                        font-size: 16px;
                      "
                    >
                      {{ rowLabel(item) }}
                    </div>
                  </div>

                  <div>
                    <mat-icon
                      style="
                        color: var(--app-timber);
                        cursor: pointer;
                        margin-right: 5px;
                      "
                      (click)="editConfiguration(item)"
                      >edit</mat-icon
                    >
                    <mat-icon
                      style="color: red; cursor: pointer"
                      (click)="deleteConfiguration(item._id!)"
                      >cancel</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div
                *ngIf="canAddConfiguration"
                class="add-container"
                (click)="addConfiguration()"
              >
                <div class="popup-subtitle" style="color: var(--app-text-grey)">
                  + Add a Configuration
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Zapier Connection -->
      <div
        style="margin-top: 20px"
        *ngIf="integration.value == integrations.zapier"
      >
        <form [formGroup]="form">
          <div class="form-field" style="margin-top: 20px">
            <div
              class="form-field-label"
              style="color: var(--app-timber); margin-bottom: 0px"
            >
              API Key
            </div>
            <link-text
              (onTapped)="showInfoDialog(titleOneZapier, bodyOneZapier)"
              text="What should I do with this?"
            ></link-text>

            <div *ngIf="!zapierConfig?.signingKey" style="margin-top: 10px">
              <app-primary-button
                [title]="'Generate API Key'"
                [disabled]="loading"
                border="1px solid var(--app-timber)"
                color="var(--app-timber)"
                (tapped)="generateZapierApiKey()"
              ></app-primary-button>
            </div>

            <div
              *ngIf="zapierConfig?.signingKey"
              style="display: flex; align-items: center; cursor: pointer"
            >
              <input
                type="text"
                class="form-input"
                [formControl]="zapierAPIKeyFormControl"
                readonly
              />
              <div
                class="copy"
                (click)="copyApiKey(zapierAPIKeyFormControl, 'Zapier')"
              >
                <mat-icon class="copy-icon">{{ "content_copy" }}</mat-icon
                ><span>Copy</span>
              </div>
            </div>
          </div>

          <!-- Webhook Subscriptions -->
          <div
            class="form-field"
            style="margin-top: 30px"
            *ngIf="
              zapierConfig?.signingKey &&
              getActiveSubscriptions(zapierConfig).length > 0
            "
          >
            <div
              class="form-field-label"
              style="color: var(--app-timber); margin-bottom: 10px"
            >
              Active Webhook Subscriptions
            </div>
            <div
              *ngFor="let subscription of getActiveSubscriptions(zapierConfig)"
              style="
                padding: 12px;
                margin-bottom: 8px;
                background-color: var(--app-background-secondary);
                border-radius: 8px;
                border: 1px solid var(--app-border);
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>
                  <div
                    style="
                      font-weight: 500;
                      color: var(--app-timber);
                      margin-bottom: 4px;
                    "
                  >
                    {{ formatSubscriptionEvent(subscription.event) }}
                  </div>
                  <div
                    style="
                      font-size: 12px;
                      color: var(--app-text-secondary);
                      word-break: break-all;
                    "
                  >
                    {{ subscription.hookUrl }}
                  </div>
                  <div
                    style="
                      font-size: 11px;
                      color: var(--app-text-tertiary);
                      margin-top: 4px;
                    "
                    *ngIf="subscription.createdAt"
                  >
                    Created: {{ subscription.createdAt | date: "short" }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-field"
            style="margin-top: 20px"
            *ngIf="
              zapierConfig?.signingKey &&
              getActiveSubscriptions(zapierConfig).length === 0
            "
          >
            <div
              style="
                font-size: 14px;
                color: var(--app-text-secondary);
                font-style: italic;
              "
            >
              No active webhook subscriptions. Subscriptions will appear here
              when you set up Zaps in Zapier.
            </div>
          </div>
        </form>
      </div>

      <!-- Epos Now -->
      <div
        style="margin-top: 20px"
        *ngIf="integration.value == integrations.eposnow"
      >
        <form [formGroup]="form">
          <div class="form-field" style="margin-top: 20px">
            <div
              class="form-field-label"
              style="
                color: var(--app-timber);
                margin-bottom: 0px;
                margin-top: 20px;
              "
            >
              Authorization Token<span style="color: red">*</span>
            </div>

            <link-text
              (onTapped)="
                showInfoDialog(accessTokenTitleEposnow, accessTokenBodyEposnow)
              "
              text="Where can I find this?"
            ></link-text>

            <div style="display: flex; align-items: center">
              <input
                type="text"
                class="form-input"
                [formControl]="eposNowAccessToken"
              />
            </div>
          </div>

          <div class="form-field" style="margin-top: 20px">
            <div
              class="form-field-label"
              style="color: var(--app-timber); margin-bottom: 0px"
            >
              Webhook URL
            </div>

            <link-text
              (onTapped)="showInfoDialog(titleOneEposnow, bodyOneEposNow)"
              text="What should I do with this?"
            ></link-text>

            <div style="display: flex; align-items: center; cursor: pointer">
              <input
                type="text"
                class="form-input"
                [formControl]="webhookEposNowFormControl"
              />
              <div class="copy" (click)="copyWebhookUrl()">
                <mat-icon class="copy-icon">{{ "content_copy" }}</mat-icon
                ><span>Copy</span>
              </div>
            </div>
          </div>

          <div
            class="form-field"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div class="form-field-label">
              Automatically create customers in EposNow<span>
                <info-icon [text]="addCustomersTooltip"></info-icon>
              </span>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="addEposNowCustomers"
              (change)="addEposNowCustomers = !addEposNowCustomers"
            >
            </mat-slide-toggle>
          </div>

          <div
            class="form-field"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div class="form-field-label">
              Invite customers without a Remy account via email<span>
                <info-icon [text]="inviteUsersTooltip"></info-icon>
              </span>
              <link-text
                (onTapped)="viewExampleMail()"
                text="View sample email"
              ></link-text>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="inviteUsersEposNow"
              (change)="inviteUsersEposNow = !inviteUsersEposNow"
            >
            </mat-slide-toggle>
          </div>

          <div *ngIf="eposnowConfig?.accessToken">
            <div class="form-field">
              <div class="form-field-label" style="color: var(--app-timber)">
                Configurations
              </div>

              <div style="margin-bottom: 20px">
                <div
                  class="social-container"
                  *ngFor="let item of eposnowConfig?.configurations"
                  style="
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <div
                      class="form-field-label"
                      style="
                        margin-bottom: 0px !important;
                        color: black;
                        font-size: 16px;
                      "
                    >
                      {{ rowLabel(item) }}
                    </div>
                  </div>

                  <div>
                    <mat-icon
                      style="
                        color: var(--app-timber);
                        cursor: pointer;
                        margin-right: 5px;
                      "
                      (click)="editConfiguration(item)"
                      >edit</mat-icon
                    >
                    <mat-icon
                      style="color: red; cursor: pointer"
                      (click)="deleteConfiguration(item._id!)"
                      >cancel</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div
                *ngIf="canAddConfiguration"
                class="add-container"
                (click)="addConfiguration()"
              >
                <div class="popup-subtitle" style="color: var(--app-text-grey)">
                  + Add a Configuration
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Make -->
      <div
        style="margin-top: 20px"
        *ngIf="integration.value == integrations.make"
      >
        <form [formGroup]="form">
          <div class="form-field" style="margin-top: 20px">
            <div
              class="form-field-label"
              style="color: var(--app-timber); margin-bottom: 0px"
            >
              API Key
            </div>
            <link-text
              (onTapped)="showInfoDialog(titleOneMake, bodyOneMake)"
              text="What should I do with this?"
            ></link-text>

            <div *ngIf="!makeConfig?.signingKey" style="margin-top: 10px">
              <app-primary-button
                [title]="'Generate API Key'"
                [disabled]="loading"
                border="1px solid var(--app-timber)"
                color="var(--app-timber)"
                (tapped)="generateMakeApiKey()"
              ></app-primary-button>
            </div>

            <div
              *ngIf="makeConfig?.signingKey"
              style="display: flex; align-items: center; cursor: pointer"
            >
              <input
                type="text"
                class="form-input"
                [formControl]="makeAPIKeyFormControl"
                readonly
              />
              <div
                class="copy"
                (click)="copyApiKey(makeAPIKeyFormControl, 'Make')"
              >
                <mat-icon class="copy-icon">{{ "content_copy" }}</mat-icon
                ><span>Copy</span>
              </div>
            </div>
          </div>

          <!-- Webhook Subscriptions -->
          <div
            class="form-field"
            style="margin-top: 30px"
            *ngIf="
              makeConfig?.signingKey &&
              getActiveSubscriptions(makeConfig).length > 0
            "
          >
            <div
              class="form-field-label"
              style="color: var(--app-timber); margin-bottom: 10px"
            >
              Active Webhook Subscriptions
            </div>
            <div
              *ngFor="let subscription of getActiveSubscriptions(makeConfig)"
              style="
                padding: 12px;
                margin-bottom: 8px;
                background-color: var(--app-background-secondary);
                border-radius: 8px;
                border: 1px solid var(--app-border);
              "
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div>
                  <div
                    style="
                      font-weight: 500;
                      color: var(--app-timber);
                      margin-bottom: 4px;
                    "
                  >
                    {{ formatSubscriptionEvent(subscription.event) }}
                  </div>
                  <div
                    style="
                      font-size: 12px;
                      color: var(--app-text-secondary);
                      word-break: break-all;
                    "
                  >
                    {{ subscription.hookUrl }}
                  </div>
                  <div
                    style="
                      font-size: 11px;
                      color: var(--app-text-tertiary);
                      margin-top: 4px;
                    "
                    *ngIf="subscription.createdAt"
                  >
                    Created: {{ subscription.createdAt | date: "short" }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-field"
            style="margin-top: 20px"
            *ngIf="
              makeConfig?.signingKey &&
              getActiveSubscriptions(makeConfig).length === 0
            "
          >
            <div
              style="
                font-size: 14px;
                color: var(--app-text-secondary);
                font-style: italic;
              "
            >
              No active webhook subscriptions. Subscriptions will appear here
              when you set up scenarios in Make.
            </div>
          </div>
        </form>
      </div>
    </mat-tab>

    <mat-tab
      label="Configuration"
      *ngIf="integration.value === integrations.make && makeConfig?.signingKey"
    >
      <!-- Make Configuration -->
      <div style="margin-top: 20px">
        <form [formGroup]="form">
          <div
            class="form-field"
            style="display: flex; justify-content: space-between"
          >
            <div class="form-field-label">
              Invite customers without a Remy account via email<span>
                <info-icon [text]="inviteUsersTooltip"></info-icon>
              </span>
              <link-text
                (onTapped)="viewExampleMail()"
                text="View sample email"
              ></link-text>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="inviteUsersMake"
              (change)="inviteUsersMake = !inviteUsersMake"
            >
            </mat-slide-toggle>
          </div>

          <div
            class="form-field"
            style="display: flex; justify-content: space-between"
          >
            <div class="form-field-label">
              Award stamps/points for orders created via Make<span>
                <info-icon [text]="awardStampsMakeTooltip"></info-icon>
              </span>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="awardStampsMake"
              (change)="awardStampsMake = !awardStampsMake"
            >
            </mat-slide-toggle>
          </div>

          <div *ngIf="awardStampsMake">
            <div class="form-field">
              <div class="form-field-label" style="color: var(--app-timber)">
                Configurations
              </div>

              <div style="margin-bottom: 20px">
                <div
                  class="social-container"
                  *ngFor="let item of makeConfig?.configurations"
                  style="
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <div
                      class="form-field-label"
                      style="
                        margin-bottom: 0px !important;
                        color: black;
                        font-size: 16px;
                      "
                    >
                      {{ rowLabel(item) }}
                    </div>
                  </div>

                  <div>
                    <mat-icon
                      style="
                        color: var(--app-timber);
                        cursor: pointer;
                        margin-right: 5px;
                      "
                      (click)="editConfiguration(item)"
                      >edit</mat-icon
                    >
                    <mat-icon
                      style="color: red; cursor: pointer"
                      (click)="deleteConfiguration(item._id!)"
                      >cancel</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div
                *ngIf="canAddConfiguration"
                class="add-container"
                (click)="addConfiguration()"
              >
                <div class="popup-subtitle" style="color: var(--app-text-grey)">
                  + Add a Configuration
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-field"
            style="display: flex; justify-content: space-between"
          >
            <div class="form-field-label">
              Enable automatic reward redemption via coupon codes<span>
                <info-icon [text]="rewardAutomationMakeTooltip"></info-icon>
              </span>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="rewardAutomationMake"
              (change)="rewardAutomationMake = !rewardAutomationMake"
            >
            </mat-slide-toggle>
          </div>
        </form>
      </div>
    </mat-tab>

    <mat-tab
      label="Configuration"
      *ngIf="
        integration.value === integrations.zapier && zapierConfig?.signingKey
      "
    >
      <!-- Zapier Configuration -->
      <div style="margin-top: 20px">
        <form [formGroup]="form">
          <div
            class="form-field"
            style="display: flex; justify-content: space-between"
          >
            <div class="form-field-label">
              Invite customers without a Remy account via email<span>
                <info-icon [text]="inviteUsersTooltip"></info-icon>
              </span>
              <link-text
                (onTapped)="viewExampleMail()"
                text="View sample email"
              ></link-text>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="inviteUsersZapier"
              (change)="inviteUsersZapier = !inviteUsersZapier"
            >
            </mat-slide-toggle>
          </div>

          <div
            class="form-field"
            style="
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div class="form-field-label">
              Award stamps/points for orders created via Zapier<span>
                <info-icon [text]="awardStampsZapierTooltip"></info-icon>
              </span>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="awardStampsZapier"
              (change)="awardStampsZapier = !awardStampsZapier"
            >
            </mat-slide-toggle>
          </div>

          <div *ngIf="awardStampsZapier">
            <div class="form-field">
              <div class="form-field-label" style="color: var(--app-timber)">
                Configurations
              </div>

              <div style="margin-bottom: 20px">
                <div
                  class="social-container"
                  *ngFor="let item of zapierConfig?.configurations"
                  style="
                    margin-top: 10px;
                    display: flex;
                    justify-content: space-between;
                  "
                >
                  <div style="display: flex; align-items: center">
                    <div
                      class="form-field-label"
                      style="
                        margin-bottom: 0px !important;
                        color: black;
                        font-size: 16px;
                      "
                    >
                      {{ rowLabel(item) }}
                    </div>
                  </div>

                  <div>
                    <mat-icon
                      style="
                        color: var(--app-timber);
                        cursor: pointer;
                        margin-right: 5px;
                      "
                      (click)="editConfiguration(item)"
                      >edit</mat-icon
                    >
                    <mat-icon
                      style="color: red; cursor: pointer"
                      (click)="deleteConfiguration(item._id!)"
                      >cancel</mat-icon
                    >
                  </div>
                </div>
              </div>

              <div
                *ngIf="canAddConfiguration"
                class="add-container"
                (click)="addConfiguration()"
              >
                <div class="popup-subtitle" style="color: var(--app-text-grey)">
                  + Add a Configuration
                </div>
              </div>
            </div>
          </div>

          <div
            class="form-field"
            style="display: flex; justify-content: space-between"
          >
            <div class="form-field-label">
              Enable automatic reward redemption via coupon codes<span>
                <info-icon [text]="rewardAutomationZapierTooltip"></info-icon>
              </span>
            </div>
            <mat-slide-toggle
              [disabled]="false"
              [checked]="rewardAutomationZapier"
              (change)="rewardAutomationZapier = !rewardAutomationZapier"
            >
            </mat-slide-toggle>
          </div>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<div mat-dialog-actions>
  <div class="action-container">
    <div class="left-buttons" *ngIf="isNotEmpty(config)">
      <app-primary-button
        [disabled]="loading"
        [title]="'Orders'"
        (tapped)="viewData()"
        color="black"
        border="1px solid var(--app-text-grey)"
        icon="shopping_cart"
      ></app-primary-button>
      <app-primary-button
        [disabled]="loading"
        [title]="'Invites'"
        (tapped)="viewInvites()"
        color="black"
        border="1px solid var(--app-text-grey)"
        icon="email"
      ></app-primary-button>
    </div>

    <div class="right-buttons">
      <app-secondary-button
        *ngIf="isNotEmpty(config)"
        [title]="'Remove Integration'"
        [disabled]="saving"
        (tapped)="remove()"
        style="margin-right: 10px"
      ></app-secondary-button>
      <app-primary-button
        *ngIf="hasIntegration"
        [disabled]="!merchantActive || !hasIntegration || loading || !canSave"
        [tooltip]="!merchantActive ? 'Merchant account inactive' : ''"
        [title]="'Save'"
        (tapped)="save()"
        bgColor="var(--app-timber)"
        color="white"
      ></app-primary-button>
    </div>
  </div>
</div>

<loader [loading]="saving || loading"></loader>
